import { render } from "./RecipeDetail.vue?vue&type=template&id=6fa9d5ec&scoped=true"
import script from "./RecipeDetail.vue?vue&type=script&lang=js"
export * from "./RecipeDetail.vue?vue&type=script&lang=js"

import "./RecipeDetail.vue?vue&type=style&index=0&id=6fa9d5ec&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/todaymeal_front/todaymeal_front/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa9d5ec"]])

export default __exports__